var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnrollment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h{fill:#00cc0a;}.i{fill:#fff;}.j{fill:url(#b);opacity:.35;}.k{fill:#dfffc0;}.l{fill:#678d98;}.m{fill:#606060;opacity:.23;}.m,.n{isolation:isolate;}.n{fill:#144c07;opacity:.7;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.15,
    y1: 79.85,
    x2: 47.15,
    y2: 3.35,
    gradientTransform: "translate(0 86) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19ff55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007f0f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m0,32C0,20.8,0,15.2,2.18,10.92c1.92-3.76,4.98-6.82,8.74-8.74C15.2,0,20.8,0,32,0h22c11.2,0,16.8,0,21.08,2.18,3.76,1.92,6.82,4.98,8.74,8.74,2.18,4.28,2.18,9.88,2.18,21.08v22c0,11.2,0,16.8-2.18,21.08-1.92,3.76-4.98,6.82-8.74,8.74-4.28,2.18-9.88,2.18-21.08,2.18h-22c-11.2,0-16.8,0-21.08-2.18-3.76-1.92-6.82-4.98-8.74-8.74-2.18-4.28-2.18-9.88-2.18-21.08v-22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m57.93,18.14v52.24c0,1.19-.96,2.15-2.15,2.15H15.72c-1.19,0-2.15-.96-2.15-2.15V18.14c0-1.19.96-2.15,2.15-2.15h8.55l1.14,1.77.78-1.77h19.11l.85,1.19,1.07-1.19h8.55c1.19,0,2.15.96,2.15,2.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m57.93,18.14v52.24c0,1.19-.96,2.15-2.15,2.15h-5.76c1.19,0,2.15-.96,2.15-2.15V18.14c0-1.19-.96-2.15-2.15-2.15h5.76c1.19,0,2.15.96,2.15,2.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m53.79,17.79H17.89c-1.01,0-1.83.82-1.83,1.83v24.41c3.21-2.79,7.37-4.53,11.62-4.53,9.87,0,17.17,8.07,17.6,17.6.23,5.03-2.15,9.64-5.78,12.89h14.31c1.01,0,1.83-.82,1.83-1.83V19.62c0-1.01-.82-1.83-1.83-1.83Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 28.24,
    cy: 56.4,
    r: 13.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "l",
    d: "m20.95,32.65h31.25c.81.02,1.48-.52,1.51-1.2.02-.69-.61-1.26-1.41-1.28h-31.35c-.81-.02-1.48.52-1.51,1.2s.61,1.26,1.41,1.28h.09Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "l",
    d: "m20.95,37.63h31.25c.81.02,1.48-.52,1.51-1.2.02-.69-.61-1.26-1.41-1.28h-31.35c-.81-.02-1.48.52-1.51,1.2s.61,1.26,1.41,1.28h.09Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "l",
    d: "m43.04,44.37h9.95c.69-.02,1.22-.6,1.2-1.28-.02-.66-.55-1.18-1.2-1.2h-9.95c-.69-.02-1.26.52-1.28,1.2-.02.69.52,1.26,1.2,1.28h.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "l",
    d: "m52.86,55.78h-4.97c-.69-.02-1.26.52-1.28,1.2-.02.69.52,1.26,1.2,1.28h5.05c.69-.02,1.22-.6,1.2-1.28-.02-.66-.55-1.18-1.2-1.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m25.63,59.55c.53.53,1.25.82,1.99.82s1.47-.29,2-.82l4.99-5c.47-.57.45-1.39-.08-1.92s-1.36-.55-1.92-.08l-5,4.99-3-3c-.55-.55-1.45-.55-1.99,0-.26.26-.42.63-.42,1s.14.74.42,1l3,3h.01Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "g",
    className: "l",
    d: "m65.08,27.65h-1.66c-2.06,0-3.73,1.67-3.73,3.73v30.67c0,.19.05.38.13.56l3.32,6.63c.31.61,1.06.86,1.67.55.24-.12.43-.31.55-.55l3.31-6.64c.09-.17.13-.36.13-.56v-30.67c0-2.06-1.67-3.73-3.73-3.73h0Zm-1.66,2.49h1.66c.69,0,1.24.56,1.24,1.24v2.9h-4.15v-2.9c0-.69.56-1.24,1.24-1.24h0Zm-.85,33.48l.17-.13c1.17-.92,2.86-.71,3.78.46h0c.49.63.38,1.54-.25,2.04l-.98.77c-.63.49-1.54.38-2.04-.25l-.89-1.14c-.43-.54-.32-1.32.21-1.74h0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m41.04,16.11l-5.18,1.89-5.18-1.89c-.94,0-1.71-.82-1.71-1.84v-2.55c0-1.02.76-1.84,1.71-1.84h10.36c.94,0,1.71.82,1.71,1.84v2.55c0,1.02-.76,1.84-1.71,1.84Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m42.74,11.71v2.55c0,1.02-.76,1.84-1.71,1.84l-2.12.78-2.31-.78c.94,0,1.71-.82,1.71-1.84v-2.55c0-1.02-.76-1.84-1.71-1.84h4.44c.94,0,1.71.82,1.71,1.84Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m45.33,16.11v5.25c0,.62-.46,1.12-1.04,1.12h-16.87c-.57,0-1.04-.5-1.04-1.12v-5.25h-1.9v5.25c0,1.75,1.32,3.17,2.94,3.17h16.87c1.62,0,2.94-1.42,2.94-3.17v-5.25h-1.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollment);
export default __webpack_public_path__ + "static/media/Enrollment.d6e767db5ce018ab53fe7c8ec3074440.svg";
export { ForwardRef as ReactComponent };